import { BarChart3, Building2, Car, ClipboardCheck, CloudUpload, FileBadge, FileClock, FileSpreadsheet, FileUp, FolderKanban, KeyRound, Settings, ShieldAlert, Truck, UserRound, Users, type LucideIcon } from "lucide-react";
import type { Role } from "../types";

export type MenuItem = { to: string; label: string; icon: LucideIcon; roles?: Role[] };
export type MenuGroup = { key: string; label: string; items: MenuItem[] };
export type NavBadge = { count: number; tone: "danger" | "warning" | "info" };
export type NavBadges = Record<string, NavBadge | undefined>;

export const menuGroups: MenuGroup[] = [
  { key: "operation", label: "Operação", items: [
    { to: "/", label: "Dashboard", icon: BarChart3 },
    { to: "/vistorias/nova", label: "Nova vistoria", icon: ClipboardCheck, roles: ["admin", "inspector"] },
    { to: "/pendentes", label: "Pendentes de envio", icon: CloudUpload, roles: ["admin", "inspector"] },
    { to: "/vistorias", label: "Histórico", icon: FileClock },
    { to: "/reprovacoes", label: "Reprovações", icon: ShieldAlert }
  ] },
  { key: "records", label: "Cadastros", items: [
    { to: "/veiculos", label: "Veículos", icon: Car },
    { to: "/motoristas", label: "Motoristas", icon: UserRound },
    { to: "/empresas", label: "Empresas", icon: Truck },
    { to: "/clientes", label: "Clientes", icon: Building2, roles: ["admin"] },
    { to: "/projetos", label: "Projetos", icon: FolderKanban, roles: ["admin"] }
  ] },
  { key: "compliance", label: "Conformidade", items: [
    { to: "/documentos", label: "Documentos", icon: FileBadge },
    { to: "/credenciais", label: "Credenciais", icon: KeyRound }
  ] },
  { key: "data", label: "Dados", items: [
    { to: "/exportar", label: "Exportar dados", icon: FileSpreadsheet },
    { to: "/importar", label: "Importar dados", icon: FileUp, roles: ["admin"] }
  ] },
  { key: "admin", label: "Administração", items: [
    { to: "/administracao", label: "Administração", icon: Users, roles: ["admin"] },
    { to: "/configuracoes", label: "Configurações", icon: Settings, roles: ["admin"] }
  ] }
];

export function isMenuItemActive(pathname: string, target: string) {
  if (target === "/") return pathname === "/";
  if (target === "/vistorias") return pathname === target || (/^\/vistorias\/[^/]+(?:\/editar)?$/.test(pathname) && pathname !== "/vistorias/nova");
  return pathname === target;
}

/** Grupos com apenas os itens que o perfil pode ver (grupos vazios somem). */
export function visibleGroups(role: Role): MenuGroup[] {
  return menuGroups
    .map((group) => ({ ...group, items: group.items.filter((item) => !item.roles || item.roles.includes(role)) }))
    .filter((group) => group.items.length > 0);
}

/** Selos do menu: pendências do aparelho e vencimentos. Vencido (vermelho) tem prioridade sobre a vencer (âmbar). */
export function buildBadges(input: { pending: number; documents?: { expired: number; expiring: number }; credentials?: { expired: number; expiring: number } }): NavBadges {
  const tone = (value?: { expired: number; expiring: number }): NavBadge | undefined => {
    if (!value) return undefined;
    const count = value.expired + value.expiring;
    return count > 0 ? { count, tone: value.expired > 0 ? "danger" : "warning" } : undefined;
  };
  return {
    "/pendentes": input.pending > 0 ? { count: input.pending, tone: "info" } : undefined,
    "/documentos": tone(input.documents),
    "/credenciais": tone(input.credentials)
  };
}
